var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16797 1.75V4.08333C8.16797 4.23804 8.22943 4.38642 8.33882 4.49581C8.44822 4.60521 8.59659 4.66667 8.7513 4.66667H11.0846M8.16797 1.75H4.08464C3.77522 1.75 3.47847 1.87292 3.25968 2.09171C3.04089 2.3105 2.91797 2.60725 2.91797 2.91667V11.0833C2.91797 11.3928 3.04089 11.6895 3.25968 11.9083C3.47847 12.1271 3.77522 12.25 4.08464 12.25H9.91797C10.2274 12.25 10.5241 12.1271 10.7429 11.9083C10.9617 11.6895 11.0846 11.3928 11.0846 11.0833V4.66667M8.16797 1.75L11.0846 4.66667M7.0013 9.91667V6.41667M7.0013 9.91667L5.54297 8.45833M7.0013 9.91667L8.45964 8.45833",
    stroke: "#5441D8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload);
export default __webpack_public_path__ + "static/media/file-download.c818d70702c933d90d7f895db51f3c96.svg";
export { ForwardRef as ReactComponent };